export default "__VITE_ASSET__DWjRWm8A__"